(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-vn-city-picker]').forEach(picker => {
      if (picker.dataset.vnCityBound) return;
      const form = picker.querySelector('[data-vn-city-form]');
      const select = picker.querySelector('[data-vn-city-select]');
      if (!form || !select) return;
      picker.dataset.vnCityBound = 'true';
      const search = picker.querySelector('[data-vn-city-search]');
      const status = picker.querySelector('[data-vn-city-status]');
      const submit = picker.querySelector('[data-vn-city-submit]');
      const directory = picker.querySelector('[data-vn-city-directory]');
      const tiles = Array.from(picker.querySelectorAll('[data-vn-city-tile]'));
      const options = Array.from(select.options).map(option => option.cloneNode(true));
      if (search) search.addEventListener('input', () => {
        const query = search.value.trim().toLocaleLowerCase();
        const previous = select.value;
        if (directory && query) directory.open = true;
        tiles.forEach(tile => { tile.hidden = !tile.dataset.vnCityMatch.toLocaleLowerCase().includes(query); });
        const matches = options.filter(option => option.value && option.textContent.toLocaleLowerCase().includes(query));
        select.replaceChildren(options[0].cloneNode(true), ...matches.map(option => option.cloneNode(true)));
        select.value = matches.length === 1 ? matches[0].value : matches.some(option => option.value === previous) ? previous : '';
        if (submit) submit.disabled = matches.length === 0;
        if (status) status.textContent = !query ? '' : matches.length === 0 ? 'No matching city or state. Try another name.' : `${matches.length} ${matches.length === 1 ? 'collection' : 'collections'} found.`;
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!select.value) { select.reportValidity(); return; }
        const destination = new URL(select.value, window.location.origin);
        if (destination.origin === window.location.origin && destination.pathname.startsWith('/collections/')) {
          window.location.assign(destination.href);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
